// @mui
import { Grid, Button, Card, CardContent, Dialog, Typography, Stack, Box, SvgIcon, Drawer, useMediaQuery, IconButton, Link } from '@mui/material';
import SlickSlider from 'react-slick';
// sections
import { LoginForm } from 'sections/auth/login';
import { useEffect, useState } from 'react';
const loginbanner = `${process.env.REACT_APP_HOMEPAGE}assets/login_side_banner.png`;
import { useTheme } from '@mui/material/styles';
import Typewriter from "typewriter-effect";

import SideBanner from 'components/basic-profile/SideBannerPage';
/**
 * A component that renders a login page. The page consists of a form to fill in
 * login credentials and a banner with some text and a slider that showcases
 * different job categories.
 *
 * @returns {JSX.Element}
 */
export default function LoginPage() {
  const theme = useTheme();

  var settings = {
    autoplay: true,
    fade: true,
    autoplaySpeed: 3000,
    speed: 1000,
    prevArrow: false,
    nextArrow: false
  };

  return (
    <Box sx={{ overflow: 'hidden' }}>
      <Grid container justifyContent={'center'} alignItems={'center'}>
        <Grid item xs={12} md={6} lg={6}>
          {/* Login form block */}
          <LoginForm />
        </Grid>
        <Grid item xs={12} md={6} lg={6} sx={{ display: { xs: 'none', md: 'block' } }}>
          <SideBanner />
        </Grid>
      </Grid>
    </Box>
  );
}